import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 자원 WIP 프로파일(공장>스테이지>자원>고객>공정그룹>공정별 재공 수량 추이) — 크로스탭 그리드용.
// AnalysisController#getResrcWipProfileGrid(백엔드는 factoryplan/analysis/resrc-wip-profile).
// 같은 { crosstabHeader, chartHeader, data[].pivotData } 형태. old에도 Set Filter(changes)가
// 그리드/차트 재조회에 실제로 연결돼 있지 않았으므로(loadData/loadChartData 어디서도
// searchOptGroupRef 값을 안 읽음) postFields가 아니라 postParams만 쓴다.
const getResrcWipProfiles = (params) => fpApiUtil.postParams(`${ANALYSIS}/resrc-wip-profile`, params);
const getResrcWipProfileChart = (params) => fpApiUtil.postParams(`${ANALYSIS}/resrc-wip-profile`, params);

const fpResrcWipProfileService = { getResrcWipProfiles, getResrcWipProfileChart };
export default fpResrcWipProfileService;
